"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from "react";
import { FallbackImage } from "@/components/common/FallbackImage";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { useInView } from "@/hooks/useInView";
interface Props {
  readonly src: string;
  readonly imageScale?: ImageScale | undefined;
}
function MediaDisplayImage(t0) {
  const $ = _c(13);
  const {
    src,
    imageScale: t1
  } = t0;
  const imageScale = t1 === undefined ? ImageScale.AUTOx600 : t1;
  const [ref, inView] = useInView();
  const [isLoading, setIsLoading] = useState(true);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsLoading(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleImageLoad = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const loadingPlaceholderStyle = t3;
  let t4;
  if ($[2] !== isLoading) {
    t4 = isLoading && <div className="tw-bg-iron-800 tw-animate-pulse tw-rounded-xl" style={loadingPlaceholderStyle} />;
    $[2] = isLoading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== imageScale || $[5] !== inView || $[6] !== isLoading || $[7] !== src) {
    t5 = inView && <FallbackImage primarySrc={getScaledImageUri(src, imageScale)} fallbackSrc={src} alt="Media content" fill={true} sizes="(max-width: 768px) 100vw, 600px" className={`tw-object-contain tw-max-w-full ${isLoading ? "tw-opacity-0" : "tw-opacity-100"}`} onLoad={handleImageLoad} onError={handleImageLoad} />;
    $[4] = imageScale;
    $[5] = inView;
    $[6] = isLoading;
    $[7] = src;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ref || $[10] !== t4 || $[11] !== t5) {
    t6 = <div ref={ref} className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-relative tw-mx-[1px]">{t4}{t5}</div>;
    $[9] = ref;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export default React.memo(MediaDisplayImage);